import React from 'react';
import { Box } from '@mui/material';
import * as styles from './styles';

// Placed at the top of an anchorable section. Zero height, so it never
// affects layout — position:relative lets it "land" above the section's
// real content by roughly the sticky TopBar's height, so jumping to #id
// doesn't leave the section's heading hidden underneath the bar.
function SectionAnchor({ id }) {
    return <Box id={id} sx={styles.anchor} />;
}

export default SectionAnchor;
